import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import CurrencyFormat from '../../components/CurrencyFormat';
import CS from '../../constants/Styles';

export default function RecentActivityItem ({ item }){
  return (
    <View style={styles.container}>
      <View style={styles.inner}>
        <Text style={[CS.smallText, CS.lightText, styles.description]}>{item.description}</Text>
        <Text style={[CS.smallText, CS.lightText, styles.currency]}>
          <CurrencyFormat value={item.amount} />
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    
  },
  inner: {
    flexDirection: 'row',
    marginTop:5
  },
  currency: {
    marginLeft: 'auto',
    fontSize: 20,
  },
  description: {
    flexWrap: 'wrap',
    // flexBasis: 0,
    maxWidth: '70%'
  }
})